export const CHANGE_ANNOUNCEMENT_FIELD = 'CHANGE_ANNOUNCEMENT_FIELD' as const
export const SUBMIT_ANNOUNCEMENT = 'SUBMIT_ANNOUNCEMENT' as const
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT' as const
export const VALIDATE_ANNOUNCEMENT_FIELD = 'VALIDATE_ANNOUNCEMENT_FIELD' as const
export const ADD_ANNOUNCEMENT_FIELD_ERROR = 'ADD_ANNOUNCEMENT_FIELD_ERROR' as const
export const ADD_ANNOUNCEMENT_FIELDS_ERRORS = 'ADD_ANNOUNCEMENT_FIELDS_ERRORS' as const
export const CLEAR_ANNOUNCEMENT_FIELD_ERROR = 'CLEAR_ANNOUNCEMENT_FIELD_ERROR' as const
export const PREDEFINE_ANNOUNCEMENT_FORM_DATA = 'PREDEFINE_ANNOUNCEMENT_FORM_DATA' as const
export const RESET_ANNOUNCEMENT_FORM_DATA = 'RESET_ANNOUNCEMENT_FORM_DATA' as const

export function changeAnnouncementFormField(key: string, value: string) {
  return {
    type: CHANGE_ANNOUNCEMENT_FIELD,
    payload: {
      key,
      value,
    },
  }
}

export interface SubmitAnnouncementPayload {
  title: { value: string; validations?: string }
  content: { value: string; validations?: string }
  thumbnail_url?: { value: string; validations?: string }
  id?: { value: string }
}

export function submitAnnouncementFrom(payload: SubmitAnnouncementPayload) {
  return {
    type: SUBMIT_ANNOUNCEMENT,
    payload,
  }
}

export function addFieldError({ field, error }: { field: string; error: string }) {
  return {
    type: ADD_ANNOUNCEMENT_FIELD_ERROR,
    payload: {
      error,
      field,
    },
  }
}

export function addFieldsErrors(errors: Record<string, string | undefined>) {
  return {
    type: ADD_ANNOUNCEMENT_FIELDS_ERRORS,
    payload: {
      errors,
    },
  }
}

export function clearFieldError({ field }: { field: string }) {
  return {
    type: CLEAR_ANNOUNCEMENT_FIELD_ERROR,
    payload: {
      field,
    },
  }
}

export function predefineAnnouncementForm(
  payload: Partial<{ title: string; content: string; thumbnail_url: string }>,
) {
  return {
    type: PREDEFINE_ANNOUNCEMENT_FORM_DATA,
    payload,
  }
}

export function resetAnnouncementForm() {
  return {
    type: RESET_ANNOUNCEMENT_FORM_DATA,
  }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string
  validations?: string
}) {
  return {
    type: VALIDATE_ANNOUNCEMENT_FIELD,
    payload: {
      field,
      value,
      validations,
    },
  }
}

export function deleteAnnouncement({ announcementId }: { announcementId: string }) {
  return {
    type: DELETE_ANNOUNCEMENT,
    payload: { announcementId },
  }
}
